import React, {Component, Fragment} from 'react';

// Default labels (you can override by passing a `labels` prop)
const DEFAULT_LABELS = {
  1: 'Unacceptable',
  2: 'Fair',
  3: 'Good',
  4: 'Excellent',
  5: 'Superior',
};

class RatingStars5 extends Component {
  constructor(props) {
    super(props);

    let rating = props.rating != null ? props.rating : 0;
    if (props.rateCount && props.rateSum) {
      rating = props.rateCount ? props.rateSum / props.rateCount : 0;
    }

    this.state = {
      rating,
      hoverRating: null,
      space: props.space ? props.space : 0,
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.rating !== prevProps.rating && this.props.rating != null) {
      this.setState({ rating: this.props.rating });
    }
    if (
      this.props.rateCount !== prevProps.rateCount ||
      this.props.rateSum !== prevProps.rateSum
    ) {
      if (this.props.rateCount && this.props.rateSum) {
        const next = this.props.rateSum / this.props.rateCount;
        this.setState({ rating: next });
      }
    }
  }

  handleSelect = (n) => {
    this.setState({ rating: n, hoverRating: null });
    this.props.receiveRating && this.props.receiveRating(n);
  };

  handleHover = (n) => {
    if (this.props.readOnly) return;
    this.setState({ hoverRating: n });
  };

  clearHover = () => {
    if (this.props.readOnly) return;
    this.setState({ hoverRating: null });
  };

  labelFor = (value) => {
    const labels = this.props.labels || DEFAULT_LABELS;
    const r = Math.round(value || 0);
    return labels[r] || '';
  };

  renderStar = (n) => {
    const { space } = this.state;
    const { readOnly } = this.props;

    const commonStyle = { marginRight: `${5 * space}px`, cursor: readOnly ? 'default' : 'pointer' };

    if (readOnly) {
      return (
        <i
          key={n}
          className="fa fa-star"
          style={commonStyle}
          aria-hidden="true"
        />
      );
    }

    return (
      <i
        key={n}
        className="fa fa-star"
        style={commonStyle}
        role="button"
        tabIndex={0}
        aria-label={`${n} star${n > 1 ? 's' : ''}`}
        onMouseEnter={() => this.handleHover(n)}
        onClick={() => this.handleSelect(n)}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') this.handleSelect(n);
          if (e.key === 'ArrowRight') this.handleHover(Math.min(n + 1, 5));
          if (e.key === 'ArrowLeft') this.handleHover(Math.max(n - 1, 1));
        }}
      />
    );
  };

  render() {
    const { id } = this.props;
    const { rating, hoverRating } = this.state;

    const display = hoverRating != null ? hoverRating : Math.round(rating || 0);

    return (
      <div
        style={{ display: 'inline-flex', alignItems: 'center' }}
        onMouseLeave={this.clearHover}
      >
        <div
          id={`ratingStars-${id}`}
          className={`ratingBase rating${display}`}
          style={{ display: 'inline-block' }}
          aria-label={`${display} star${display === 1 ? '' : 's'}`}
        >
          <Fragment>
            {[1, 2, 3, 4, 5].map(this.renderStar)}
          </Fragment>
        </div>

        <span className="ml-2" style={{ marginLeft: 8, whiteSpace: 'nowrap' }}>
          {this.labelFor(display)}
        </span>
      </div>
    );
  }
}

export default RatingStars5;